export const ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
export const AUTH_TOKEN = import.meta.env.VITE_TOKEN;

export const USE_MSW = import.meta.env.VITE_USE_MSW === "true";
export const USE_MIRAGE = import.meta.env.VITE_USE_MIRAGE === "true";
const USE_MINI_ENV = import.meta.env.VITE_USE_MINI_ENV === "true";

export const IS_DEMO = USE_MIRAGE === true || USE_MSW === true;

const VITE_API_URL_MIDDLEWARE = USE_MSW
  ? import.meta.env.VITE_BASE_URL_MOCK
  : import.meta.env.VITE_API_URL_MIDDLEWARE;

// Em modo demo utilizando MIRAGE, usa reef para todas as APIs (incluindo bowtie)
// Utilizando MSW, as rotas de mock já foram corrigidas para usar reef-bowtie
export const BASE_URL = USE_MIRAGE
  ? `${VITE_API_URL_MIDDLEWARE}/api/reef/api/v1`
  : `${VITE_API_URL_MIDDLEWARE}/api/reef-bowtie/api/v1`;

export const BASE_WORKFLOW_URL_V2 = USE_MINI_ENV
  ? import.meta.env.VITE_BASE_WORKFLOW_URL_V2
  : `${VITE_API_URL_MIDDLEWARE}/api/reef/api/v2`;
export const BASE_WORKFLOW_URL_V3 = USE_MINI_ENV
  ? import.meta.env.VITE_BASE_WORKFLOW_URL_V3
  : `${VITE_API_URL_MIDDLEWARE}/api/reef/api/v3`;
export const BASE_WORKFLOW_URL_V4 = USE_MINI_ENV
  ? import.meta.env.VITE_BASE_WORKFLOW_URL_V4
  : `${VITE_API_URL_MIDDLEWARE}/api/reef/api/v4`;
export const BASE_WORKFLOW_URL_V2_EPS = USE_MINI_ENV
  ? import.meta.env.VITE_BASE_WORKFLOW_URL_V2
  : `${VITE_API_URL_MIDDLEWARE}/api/reef/api/v2`;
export const BASE_POSTHOG_URL = USE_MSW
  ? import.meta.env.VITE_BASE_URL_MOCK
  : `${VITE_API_URL_MIDDLEWARE}/api/posthog`;

export const BOWTIE_DEV_MODE = 0;
export const ENABLE_FEATURE_CTO = import.meta.env.VITE_ENABLE_FEATURE_CTO;

// Auth policy versioning
export const B2C_AUTH_POLICY_VERSION = import.meta.env.VITE_AUTH_POLICY;
export const B2C_LOCAL_STORAGE_EMAIL = `userEmail_${
  import.meta.env.VITE_CLIENT_ID_B2C
}_${import.meta.env.VITE_AUTH_POLICY}`;
export const B2C_AUTH_POLICY_KEY = "authPolicyVersion";

export const REFRESH_TOKEN = "refresh-token";
export const LOGOUT_USER = "logout-user";
export const PREVIOUS_PAGE = -1;

export const B2C_POLICIES = {
  names: { signUpSignIn: import.meta.env.VITE_AUTH_POLICY },
  authorities: {
    signUpSignIn: {
      authority: `https://${import.meta.env.VITE_AUTH_TENANT}.b2clogin.com/${
        import.meta.env.VITE_AUTH_TENANT
      }.onmicrosoft.com/${import.meta.env.VITE_AUTH_POLICY}`,
    },
  },
  authorityDomain: `${import.meta.env.VITE_AUTH_TENANT}.b2clogin.com`,
};

export const BREAKPOINTS = {
  TABLET: "768px",
  DESKTOP: "1024px",
};

export const IS_TEST = import.meta.env.NODE_ENV === "test";
export const POSTHOG_API_KEY = import.meta.env.VITE_PUBLIC_POSTHOG_KEY ?? "";
export const POSTHOG_HOST = import.meta.env.VITE_PUBLIC_POSTHOG_HOST ?? "";
